import React from "react";
import translate from "components/translations/translations.wrapper";
import MissingFile from "components/taskdetails-remake/icons/missing-file.svg";
import { RotateCcw } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

interface UnavailableProps {
    callback?: () => void;
    translate?: (key: string) => string;
}

//this attachemnt has been deleted and we cannot reach it
export const Unavailable = ({translate, callback}: UnavailableProps): React.ReactElement => {

    return <div className={"unavailable-attachment bg-natural-white py-2 rounded-4"}>
        <img src={new URL(MissingFile, window.location.origin).href} alt={"missing file"}
             className={"float-left w-25"}/>
        <strong>{translate("taskDetail.panels.attachments.unavailableTitle")}</strong>
        <br/>
        <span>{translate("taskDetail.panels.attachments.unavailableDetails")}</span>
        <br/>
        <span>
            {callback &&
                <button className={"btn btn-primary btn-lg"} onClick={callback}>
                    <RotateCcw size={ICON_SIZE.SMALL} className={"mr-4"}/>
                    {translate("taskDetail.panels.attachments.tryAgain")}
                </button>
            }
        </span>
    </div>
}

export default translate(Unavailable);